<template>
    <div
        :id="id"
        class="tl-selection-list-wrapper"
    >
        <div
            class="tl-selection-list"
            :class="{ horizontal }"
            role="group"
        >
            <SelectionListTile
                v-for="(item, index) in items"
                :key="index"
                :loading="loading"
                :item="item"
                :horizontal="horizontal"
                :item-gap="itemGap"
                @click="chooseItem(item)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { SelectionListItem } from 'widget-components/integrations/CustomPage/types'
import type { CustomCssVariables } from 'widget-components/types'
import SelectionListTile from './SelectionListTile.vue'
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    horizontal?: boolean
    items: SelectionListItem[]
    loading?: boolean
    customCssVariables?: CustomCssVariables
}>()

const itemGap = computed(() => props.customCssVariables?.['--tl-container-item-gap'])

const emit = defineEmits(['itemChosen'])

const chooseItem = (item: SelectionListItem) => {
    emit('itemChosen', item)
}
</script>

<style lang="sass" scoped>
@import './SelectionList.sass'
</style>
